import {getClient, querySelector, querySelectorAll} from '../utilities';

const postalCodeInputSelector = '.js-auto-address-input-by-postal-code';


const showAddresses = (addresses: any[], button: HTMLElement) => {

  const address = (() => {
    if (addresses && addresses.length) {
      return addresses[0];
    }
    return null;
  })();


  const prefecture = querySelector(button.dataset.prefectureSelector) as HTMLInputElement;

  if (prefecture) {
    prefecture.value = address?.prefecture || '';
  }

  const city = querySelector(button.dataset.citySelector) as HTMLInputElement;
  if (city) {
    city.value = address?.city || '';
  }

  const street = querySelector(button.dataset.streetSelector) as HTMLInputElement;
  if (street) {
    street.value = address?.street || '';
  }
};


async function autoInputAddress(input: HTMLInputElement, b: HTMLButtonElement) {
  const baseUrl = '/common/api/postalCode/' + input.value;

  try {
    const response = await getClient().get(baseUrl);
    showAddresses(response.data, b);
  } catch (err) {
    console.error(err);
    return;
  }
}

const handleButtonOnClickAsync = async (e: Event) => {
  const element = e.target as HTMLElement;

  const b = ((): HTMLButtonElement => {
    if (element.tagName.toUpperCase() !== 'BUTTON') {
      return element.parentElement as HTMLButtonElement;
    }
    return element as HTMLButtonElement;
  })();

  const input = querySelector(b.dataset.inputSelector) as HTMLInputElement;
  if (!input) {
    console.warn('input not found');
    return;
  }

  if (!input.value || input.value.length < 3) {
    alert('郵便番号を3文字以上入力してください。');
    return;
  }
  await autoInputAddress(input, b);
};

const handlePostalCodeInputOnChange = async (e: Event) => {

  // 郵便番号が7文字になった時点で住所自動入力
  const input = e.currentTarget as HTMLInputElement;
  if (!input || !input.value || input.value.length != 7 ) {
    return;
  }

  if (!/^[0-9]+$/.test(input.value) ) {
    return;
  }


  // 自動入力関連の情報は「自動入力」ボタンから取得する.
  const button = input.closest('form')?.querySelector('.auto-input-address-button') as HTMLButtonElement;
  if (!button) {
    return;
  }

  // 住所自動入力
  await autoInputAddress(input, button);
};

const init = () => {
  const buttons = querySelectorAll('.auto-input-address-button');
  buttons.forEach((button: HTMLButtonElement) => {
    button.addEventListener('click', async e => {
      await handleButtonOnClickAsync(e);
    });
  });

  // ボタンをクリックせずに、住所に7文字入力した時点での住所自動入力
  querySelectorAll(postalCodeInputSelector).forEach((input: HTMLInputElement) => {
    input.addEventListener('input', handlePostalCodeInputOnChange);
  });
};

document.addEventListener('DOMContentLoaded', () => {
  init();
});
